// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"15282":"79fde7b787a331f2ebc2","15730":"79fde7b787a331f2ebc2","50308":"79fde7b787a331f2ebc2"}[chunkId] + ".css";
};